import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SortTableCellStatusDot} from '../../../../../shared/models/sort-table/cell-classes';
import {BaseCellComponent} from '../_base-cell/base-cell.component';
import {NgClass} from '@angular/common';

/**
 * Produces a cell with a status dot and status string.
 */
@Component({
  selector: 'motn-sort-table-cell-status-dot',
  template: `
    <div [ngClass]="cell.color">
      <i
        class="fa-solid fa-circle-small"
      ></i>
    </div>
    <div>
      {{ cell.label }}
    </div>
  `,
  styleUrls: ['./sort-table-cell-status-dot.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
  ],
})
export class SortTableCellStatusDotComponent extends BaseCellComponent implements OnInit {
  @Input() cell: SortTableCellStatusDot;


  constructor() {
    super();
  }


  protected onInit(): void {
  }
}
